if (!customElements.get('subscription-purchase')) {
  customElements.define(
    'subscription-purchase',
    class SubscriptionPurchase extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;
        this.productUrl = this.dataset.productUrl;
        this.variantInputs = this.querySelectorAll('.subscription-variant-card__input');
        this.freeGiftSection = this.querySelector('.free-gift-section');

        this.variantInputs.forEach((input) => {
          input.addEventListener('change', this.onVariantChange.bind(this));
        });

        const urlParams = new URLSearchParams(window.location.search);
        const urlVariantId = urlParams.get('variant');

        if (urlVariantId) {
          const urlVariantInput = Array.from(this.variantInputs).find((input) => input.value === urlVariantId);

          if (urlVariantInput && !urlVariantInput.disabled) {
            urlVariantInput.checked = true;

            this.querySelectorAll('.subscription-variant-card').forEach((card) => {
              card.classList.remove('subscription-variant-card--selected');
            });
            urlVariantInput.closest('.subscription-variant-card')?.classList.add('subscription-variant-card--selected');
          }
        } else {
          const defaultIndex = parseInt(this.dataset.defaultOfferIndex, 10) || 3;
          const targetInput = this.variantInputs[defaultIndex - 1];

          if (targetInput && !targetInput.disabled) {
            targetInput.checked = true;

            this.querySelectorAll('.subscription-variant-card').forEach((card) => {
              card.classList.remove('subscription-variant-card--selected');
            });
            targetInput.closest('.subscription-variant-card')?.classList.add('subscription-variant-card--selected');
          }
        }

        const checkedInput = this.querySelector('.subscription-variant-card__input:checked');
        if (checkedInput) {
          this.syncPurchaseInputs(checkedInput);
          this.updateGiftStates(parseInt(checkedInput.dataset.giftsUnlocked, 10) || 0);
          this.updateBuyOnceLabel(checkedInput);
          this.updateMainPrice(checkedInput);
        }
      }

      onVariantChange(event) {
        const input = event.target;
        if (!input.checked) return;

        this.querySelectorAll('.subscription-variant-card').forEach((card) => {
          card.classList.remove('subscription-variant-card--selected');
        });
        input.closest('.subscription-variant-card')?.classList.add('subscription-variant-card--selected');

        this.syncPurchaseInputs(input);
        this.updateGiftStates(parseInt(input.dataset.giftsUnlocked, 10) || 0);
        this.updateBuyOnceLabel(input);
        this.updateMainPrice(input);
        this.updateProductInfo(input.value);
      }

      syncPurchaseInputs(input) {
        const productForm = document.getElementById(this.productFormId);
        if (!productForm) return;

        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = input.value;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        let sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
        const sellingPlanId = input.dataset.sellingPlanId;

        if (sellingPlanId) {
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement('input');
            sellingPlanInput.type = 'hidden';
            sellingPlanInput.name = 'selling_plan';
            productForm.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = sellingPlanId;
          sellingPlanInput.disabled = false;
        } else if (sellingPlanInput) {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }

      updateBuyOnceLabel(input) {
        const productForm = document.getElementById(this.productFormId);
        const buyOnceButton = productForm?.closest('product-form')?.querySelector('[data-buy-once]');
        if (!buyOnceButton) return;

        let template = buyOnceButton.dataset.buyOnceTemplate || 'BUY ONCE FOR {price} + NO FREE SHIPPING';
        const formattedPrice = input.dataset.oneTimePriceFormatted || '';
        const giftsUnlocked = parseInt(input.dataset.giftsUnlocked, 10) || 0;
        const noShippingSuffix = buyOnceButton.dataset.buyOnceNoShippingSuffix || ' + NO FREE SHIPPING';

        if (giftsUnlocked > 0) {
          template = template.replace(noShippingSuffix, '');
        }

        buyOnceButton.textContent = template.replace('{price}', formattedPrice);
      }

      updateMainPrice(input) {
        const priceContainer = document.querySelector(`#price-${this.sectionId} .price`);
        if (!priceContainer) return;

        const oneTimePrice = parseInt(input.dataset.oneTimePrice, 10);
        const subscriptionPrice = parseInt(input.dataset.subscriptionPrice, 10);
        const onSale = oneTimePrice > subscriptionPrice;

        priceContainer.dataset.subscriptionPrice = subscriptionPrice;
        priceContainer.dataset.oneTimePrice = oneTimePrice;
        priceContainer.classList.toggle('price--on-sale', onSale);

        const regularPriceItem = priceContainer.querySelector('.price__regular .price-item--regular');
        const comparePriceItem = priceContainer.querySelector('.price__sale .price-item--regular');
        const salePriceItem = priceContainer.querySelector('.price__sale .price-item--sale');

        const subscriptionFormatted = input.dataset.subscriptionPriceFormatted || '';
        const oneTimeFormatted = input.dataset.oneTimePriceFormatted || '';

        if (regularPriceItem) regularPriceItem.textContent = subscriptionFormatted;
        if (comparePriceItem) comparePriceItem.textContent = oneTimeFormatted;
        if (salePriceItem) salePriceItem.textContent = subscriptionFormatted;
      }

      updateGiftStates(unlockedCount) {
        if (!this.freeGiftSection) return;

        this.freeGiftSection.dataset.giftsUnlocked = unlockedCount;

        this.freeGiftSection.querySelectorAll('.free-gift-card').forEach((card) => {
          const giftIndex = parseInt(card.dataset.giftIndex, 10);
          const isUnlocked = unlockedCount >= giftIndex && unlockedCount > 0;

          card.classList.toggle('free-gift-card--unlocked', isUnlocked);
          card.classList.toggle('free-gift-card--locked', !isUnlocked);
        });
      }

      getUnlockedGiftCartItems(parentVariantId) {
        const parentId = String(parentVariantId || '');

        return Array.from(this.querySelectorAll('.free-gift-card--unlocked'))
          .filter((card) => card.dataset.excludeFromCart !== 'true')
          .map((card) => {
            const variantId = parseInt(card.dataset.giftVariantId, 10);
            if (!variantId) return null;

            return {
              id: variantId,
              quantity: 1,
              parent_id: parentId,
              properties: {
                _free_gift: 'true',
                _rc_free_gift: 'true',
              },
            };
          })
          .filter(Boolean);
      }

      updateProductInfo(variantId) {
        const productInfo = document.querySelector(`product-info[data-section="${this.sectionId}"]`);
        if (!productInfo) return;

        const url = `${this.productUrl}?variant=${variantId}&section_id=${this.sectionId}`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const submitButton = productInfo.querySelector(`#ProductSubmitButton-${this.sectionId}`);
            const sourceSubmitButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
            const productForm = productInfo.querySelector('product-form');

            if (submitButton && sourceSubmitButton) {
              if (sourceSubmitButton.hasAttribute('disabled')) {
                submitButton.setAttribute('disabled', 'disabled');
              } else {
                submitButton.removeAttribute('disabled');
              }
            } else if (productForm) {
              productForm.toggleSubmitButton(false);
            }

            productInfo.querySelectorAll(`#${this.productFormId}, #product-form-installment-${this.sectionId}`).forEach((form) => {
              const input = form.querySelector('input[name="id"]');
              if (input) input.value = variantId;
            });

            if (productInfo.dataset.updateUrl !== 'false') {
              window.history.replaceState({}, '', `${this.productUrl}?variant=${variantId}`);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  );
}
